"use strict";
exports.__esModule = true;
exports.setupBillerEndpoints = void 0;
var utils_1 = require("../utils");
var getBasePath = (0, utils_1.getBasePathFactory)('/biller');
function setupBillerEndpoints(api) {
    return api.injectEndpoints({
        endpoints: function (build) { return ({
            getResidentPrefill: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/prefill");
                }
            }),
            getPropertyUnit: build.query({
                query: function (_a) {
                    var propertyId = _a.propertyId, unitId = _a.unitId;
                    return "".concat(getBasePath(), "/properties/").concat(propertyId, "/units/").concat(unitId);
                }
            }),
            getGenericPortals: build.query({
                query: function () { return "".concat(getBasePath(), "/portals/generic"); }
            }),
            getPortalDetailsForCustomer: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(), "/portals/details"),
                        params: { customer_public_id: customerId }
                    });
                }
            }),
            getFlexAnywhereBillerId: build.query({
                query: function () { return "".concat(getBasePath(), "/flex-anywhere/biller-id"); }
            }),
            getResidentLookup: build.query({
                query: function (_a) {
                    var client = _a.client, token = _a.token;
                    return "".concat(getBasePath(), "/property-lookup?client=").concat(client, "&token=").concat(token);
                }
            }),
            associateEmbedSubmission: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, client = _a.client, token = _a.token;
                    return ({
                        url: "".concat(getBasePath(customerId), "/embed/submission/associate"),
                        method: 'POST',
                        body: { client: client, token: token }
                    });
                }
            })
        }); }
    });
}
exports.setupBillerEndpoints = setupBillerEndpoints;
